import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/features/auth/protected-route';
import { AppShell } from '@/components/shell/app-shell';
import { DashboardPage } from '@/pages/dashboard-page';
import { LoginPage } from '@/pages/login-page';
import { FleetPanelPage } from '@/pages/fleet-panel-page';
import { OdometerEntryPage } from '@/pages/odometer-entry-page';
import { VehiclesPage } from '@/pages/vehicles-page';
import { CatalogPage } from '@/pages/catalog-page';
import { EventsPage } from '@/pages/events-page';
import { TriagePage } from '@/pages/triage-page';
import { QueuePage } from '@/pages/queue-page';
import { FieldServicePage } from '@/pages/field-service-page';
import { WorkOrdersPage } from '@/pages/work-orders-page';
import { WorkOrderPage } from '@/pages/work-order-page';
import { StockPage } from '@/pages/stock-page';
import { MetricsPage } from '@/pages/metrics-page';
import { SchedulingPage } from '@/pages/scheduling-page';
import { OperationsPage } from '@/pages/operations-page';
import { DesignKitPage } from '@/pages/design-kit-page';
import { NotFoundPage } from '@/pages/not-found-page';
import { ProfilePage } from '@/pages/profile-page';
import { UsersPage } from '@/pages/users-page';
import { PlansPage } from '@/pages/plans-page';
import { MaterialsPage } from '@/pages/materials-page';
import { TechniciansPage } from '@/pages/technicians-page';
import { DailyCheckPage } from '@/pages/daily-check-page';
import { DailyPage } from '@/pages/daily-page';
import { SuppliersPage } from '@/pages/suppliers-page';
import { PartsLabPage } from '@/pages/parts-lab-page';
import { AuditsPage } from '@/pages/audits-page';
import { ComponentsPage } from '@/pages/components-page';
import { VehiclePage } from '@/pages/vehicle-page';
import { ForgotPasswordPage, ResetPasswordPage } from '@/pages/password-pages';
import { FirstAccessPage } from '@/pages/first-access-page';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/esqueci-senha', element: <ForgotPasswordPage /> },
  { path: '/redefinir-senha', element: <ResetPasswordPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      // Senha provisória: fora do shell, antes de qualquer tela
      { path: '/primeiro-acesso', element: <FirstAccessPage /> },
      {
        element: <AppShell />,
        children: [
          // R0 — Fundacoes
          { path: '/', element: <DashboardPage /> },
          { path: '/frota', element: <FleetPanelPage /> },
          { path: '/frota/:id', element: <VehiclePage /> },
          { path: '/daily', element: <DailyPage /> },
          { path: '/checklist', element: <DailyCheckPage /> },
          { path: '/km', element: <OdometerEntryPage /> },
          { path: '/cadastros/frota', element: <VehiclesPage /> },
          { path: '/cadastros/catalogo', element: <CatalogPage /> },
          { path: '/cadastros/usuarios', element: <UsersPage /> },
          { path: '/cadastros/planos', element: <PlansPage /> },
          { path: '/cadastros/materiais', element: <MaterialsPage /> },
          { path: '/cadastros/tecnicos', element: <TechniciansPage /> },
          { path: '/cadastros/fornecedores', element: <SuppliersPage /> },
          { path: '/qualidade-pecas', element: <PartsLabPage /> },
          { path: '/auditorias', element: <AuditsPage /> },
          { path: '/componentes', element: <ComponentsPage /> },
          // R1 — Corretivo e execucao
          { path: '/eventos', element: <EventsPage /> },
          { path: '/triagem', element: <TriagePage /> },
          { path: '/fila', element: <QueuePage /> },
          { path: '/socorro', element: <FieldServicePage /> },
          { path: '/os', element: <WorkOrdersPage /> },
          { path: '/os/:id', element: <WorkOrderPage /> },
          { path: '/estoque', element: <StockPage /> },
          { path: '/indicadores', element: <MetricsPage /> },
          { path: '/design', element: <DesignKitPage /> },
          { path: '/perfil', element: <ProfilePage /> },
          // R2 — Preventiva e Plantao
          { path: '/preventiva', element: <SchedulingPage /> },
          { path: '/plantao', element: <OperationsPage /> },
        ],
      },
    ],
  },
  { path: '/404', element: <NotFoundPage /> },
  { path: '*', element: <Navigate to="/404" replace /> },
]);
